import React, { useEffect, useState } from 'react';

import PopulationContent from 'components/SocialSurvey/SocialEconomicData/PopulationContent';
import VillageEconomyAndIndustryContent from 'components/SocialSurvey/SocialEconomicData/VillageEconomyAndIndustryContent';

import TagTab from 'components/TagTab';

import village from 'data/changhua_village_FY_geo.json';

import { useLocation } from 'react-router-dom';
import { BE_URL } from 'utils/config';

function VillageContent() {
  const searchParams = new URLSearchParams(useLocation().search).get('tag');
  const [filter, setFilter] = useState({
    tag: 'population',
  });
  const [villagePopulationData, setVillagePopulationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          `${BE_URL}/api/social-economic-population-data/?scale=village`
        );
        if (!res.ok) throw new Error('Network response was not ok');
        const data = await res.json();
        setVillagePopulationData(data);
      } catch (error) {
        console.error('載入 villagePopulationData 失敗:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (searchParams === 'economy-and-industry') {
      setFilter({ ...filter, tag: 'economy-and-industry' });
    }
  }, []);

  if (loading) {
    return <div>資料載入中...</div>;
  }

  const tabList = [
    {
      id: 'population',
      title: '人口概況',
      content: (
        <PopulationContent
          scale="village"
          rawData={villagePopulationData}
          map={village}
        />
      ),
    },
    {
      id: 'economy-and-industry',
      title: '經濟與產業',
      content: <VillageEconomyAndIndustryContent />,
    },
  ];

  return (
    <>
      <article className="l-social-economy-data">
        <TagTab list={tabList} filter={filter} setFilter={setFilter} />
        {tabList.find((item) => item.id === filter.tag).content}
      </article>
    </>
  );
}

export default VillageContent;
